// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Fork_Class from "../Control.Monad.Fork.Class/index.js";
import * as Control_Monad_Rec_Class from "../Control.Monad.Rec.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
import * as Fusion_LoadIntermediate from "../Fusion.LoadIntermediate/index.js";
import * as WE_Class_AVar from "../WE.Class.AVar/index.js";
import * as WE_Class_MonadRef from "../WE.Class.MonadRef/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_List_Types.foldableList)(Fusion_Data_Speed.monoidSpeed);
var map = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var length = /* #__PURE__ */ Data_Foldable.length(Data_List_Types.foldableList);
var length1 = /* #__PURE__ */ length(Data_Semiring.semiringNumber);
var length2 = /* #__PURE__ */ length(Data_Semiring.semiringInt);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var isFinal = /* #__PURE__ */ Fusion_Generator.isFinal(/* #__PURE__ */ Fusion_Generator.isFinalEither(Fusion_LoadIntermediate.isFinalLoadOutput));
var groupedAverage = function (dictMonadApp) {
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var MonadBracket2 = dictMonadApp.MonadBracket2();
    var form2toForm1 = Fusion_Generator.form2toForm1(MonadAppNE4.ManageAVar3())(MonadAppNE4.MonadFork0())(dictMonadApp.MonadKill3())(MonadBracket2.MonadError1());
    var bracket = Control_Monad_Fork_Class.bracket(MonadBracket2);
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Applicative0 = Monad0.Applicative0();
    var pure = Control_Applicative.pure(Applicative0);
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var discard1 = discard(Bind1);
    var when = Control_Applicative.when(Applicative0);
    return function (groupSize) {
        return function (mkGen) {
            return form2toForm1(function (emit) {
                return bracket(mkGen)(function (v) {
                    return function (gen) {
                        return Fusion_Generator.cancel(gen);
                    };
                })(function (gen) {
                    var emitGroupAverage = function (v) {
                        if (v instanceof Data_List_Types.Nil) {
                            return pure(Data_Unit.unit);
                        };
                        if (v instanceof Data_List_Types.Cons) {
                            var sumSpeeds = fold(map(function (v1) {
                                return v1.speed;
                            })(v));
                            var size = length1(v);
                            var avg = Fusion_Data_Speed.fromBps(Fusion_Data_Speed.toBps(sumSpeeds) / size);
                            return emit(new Data_Either.Right(new Fusion_LoadIntermediate.TotalIntermediate({
                                speed: avg,
                                timestamp: v.value0.timestamp
                            })));
                        };
                        throw new Error("Failed pattern match at Fusion.GenTransformers (line 148, column 11 - line 148, column 60): " + [ v.constructor.name ]);
                    };
                    var loop = function (group) {
                        return bind(Fusion_Generator.next(gen))(function (v) {
                            return bind((function () {
                                if (v instanceof Data_Either.Right && v.value0 instanceof Fusion_LoadIntermediate.TotalIntermediate) {
                                    var newGroup = new Data_List_Types.Cons(v.value0.value0, group);
                                    var $73 = length2(newGroup) === groupSize;
                                    if ($73) {
                                        return discard1(emitGroupAverage(newGroup))(function () {
                                            return pure(Data_List_Types.Nil.value);
                                        });
                                    };
                                    return pure(newGroup);
                                };
                                return discard1(when(isFinal(v))(emitGroupAverage(group)))(function () {
                                    return discard1(emit(v))(function () {
                                        return pure(group);
                                    });
                                });
                            })())(function (newGroup) {
                                return when(!isFinal(v))(loop(newGroup));
                            });
                        });
                    };
                    return loop(Data_List_Types.Nil.value);
                });
            });
        };
    };
};
var batchEvents = function (dictMonadRef) {
    var $$new = WE_Class_MonadRef["new"](dictMonadRef);
    var read = WE_Class_MonadRef.read(dictMonadRef);
    var put = WE_Class_MonadRef.put(dictMonadRef);
    var modify_ = WE_Class_MonadRef.modify_(dictMonadRef);
    return function (dictMonadRec) {
        var forever = Control_Monad_Rec_Class.forever(dictMonadRec);
        return function (dictManageAVar) {
            var Monad0 = dictManageAVar.Monad0();
            var Bind1 = Monad0.Bind1();
            var bind = Control_Bind.bind(Bind1);
            var empty = WE_Class_AVar.empty(dictManageAVar);
            var discard1 = discard(Bind1);
            var put1 = WE_Class_AVar.put(dictManageAVar);
            var Applicative0 = Monad0.Applicative0();
            var pure = Control_Applicative.pure(Applicative0);
            var for_ = Data_Foldable.for_(Applicative0)(Data_Foldable.foldableMaybe);
            var take = WE_Class_AVar.take(dictManageAVar);
            return function (dictMonadKill) {
                return function (dictMonadBracket) {
                    var MonadKill0 = dictMonadBracket.MonadKill0();
                    var fork = Control_Monad_Fork_Class.fork(MonadKill0.MonadFork0());
                    var MonadError1 = dictMonadBracket.MonadError1();
                    var catchError = Control_Monad_Error_Class.catchError(MonadError1);
                    var kill_ = Fusion_Generator.kill_(MonadKill0);
                    var throwError = Control_Monad_Error_Class.throwError(MonadError1.MonadThrow0());
                    return function (dictIsFinal) {
                        var isFinal1 = Fusion_Generator.isFinal(dictIsFinal);
                        return function (v) {
                            return function (mkGen) {
                                return bind($$new([  ]))(function (refBatch) {
                                    return bind($$new(Data_Maybe.Nothing.value))(function (refCleanup) {
                                        return bind(empty)(function (avOut) {
                                            return bind(mkGen)(function (gen) {
                                                var emitBatch = bind(read(refBatch))(function (batch) {
                                                    return discard1((function () {
                                                        var v1 = Data_Array_NonEmpty.fromArray(batch);
                                                        if (v1 instanceof Data_Maybe.Just) {
                                                            return discard1(put(refBatch)([  ]))(function () {
                                                                return put1(new Data_Either.Right(v1.value0))(avOut);
                                                            });
                                                        };
                                                        if (v1 instanceof Data_Maybe.Nothing) {
                                                            return pure(Data_Unit.unit);
                                                        };
                                                        throw new Error("Failed pattern match at Fusion.GenTransformers (line 68, column 7 - line 72, column 29): " + [ v1.constructor.name ]);
                                                    })())(function () {
                                                        return pure(Data_Unit.unit);
                                                    });
                                                });
                                                var $lazy_loop = $runtime_lazy("loop", "Fusion.GenTransformers", function () {
                                                    return bind(Fusion_Generator.next(gen))(function (v1) {
                                                        return discard1(modify_(refBatch)(function (v2) {
                                                            return Data_Array.snoc(v2)(v1);
                                                        }))(function () {
                                                            var $80 = isFinal1(v1);
                                                            if ($80) {
                                                                return discard1(emitBatch)(function () {
                                                                    return bind(read(refCleanup))(function (maybeCleanup) {
                                                                        return for_(maybeCleanup)(function (cleanup) {
                                                                            return discard1(cleanup.cancelGen)(function () {
                                                                                return cleanup.killFib2;
                                                                            });
                                                                        });
                                                                    });
                                                                });
                                                            };
                                                            return $lazy_loop(86);
                                                        });
                                                    });
                                                });
                                                var loop = $lazy_loop(76);
                                                return bind(fork(catchError(loop)(function (err) {
                                                    return discard1(put1(new Data_Either.Left(err))(avOut))(function () {
                                                        return bind(read(refCleanup))(function (maybeCleanup) {
                                                            return for_(maybeCleanup)(function (cleanup) {
                                                                return discard1(cleanup.cancelGen)(function () {
                                                                    return cleanup.killFib2;
                                                                });
                                                            });
                                                        });
                                                    });
                                                })))(function (fib1) {
                                                    return bind(fork(catchError(forever(discard1(emitBatch)(function () {
                                                        return v.delay;
                                                    })))(function (err) {
                                                        return discard1(put1(new Data_Either.Left(err))(avOut))(function () {
                                                            return bind(read(refCleanup))(function (maybeCleanup) {
                                                                return for_(maybeCleanup)(function (cleanup) {
                                                                    return discard1(cleanup.cancelGen)(function () {
                                                                        return cleanup.killFib1;
                                                                    });
                                                                });
                                                            });
                                                        });
                                                    })))(function (fib2) {
                                                        return discard1(put(refCleanup)(new Data_Maybe.Just({
                                                            cancelGen: Fusion_Generator.cancel(gen),
                                                            killFib1: kill_(fib1),
                                                            killFib2: kill_(fib2)
                                                        })))(function () {
                                                            return pure({
                                                                next: bind(take(avOut))(function (val) {
                                                                    if (val instanceof Data_Either.Left) {
                                                                        return throwError(val.value0);
                                                                    };
                                                                    if (val instanceof Data_Either.Right) {
                                                                        return pure(val.value0);
                                                                    };
                                                                    throw new Error("Failed pattern match at Fusion.GenTransformers (line 124, column 9 - line 126, column 36): " + [ val.constructor.name ]);
                                                                }),
                                                                cancel: bind(read(refCleanup))(function (maybeCleanup) {
                                                                    return for_(maybeCleanup)(function (cleanup) {
                                                                        return discard1(cleanup.cancelGen)(function () {
                                                                            return discard1(cleanup.killFib1)(function () {
                                                                                return cleanup.killFib2;
                                                                            });
                                                                        });
                                                                    });
                                                                })
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};
export {
    batchEvents,
    groupedAverage
};
